import { gql } from "@apollo/client";

export const OrgSettingsOrganizationFragment = gql`
  fragment OrgSettingsOrganizationFragment on OrganizationNode {
    id
    name
    pricingTier
    pricingTierValidUntil
    membershipSetting
    domains
    goalLabel
    personal
    keyResultLabel
    teamLabel
    orgLabel
    recognitionLabel
    oneononeLabel
    reviewLabel
    expectationLabel
    conversationLabel
    developmentLabel
    competencyLabel
    effectivePricingTier
    defaultGoalState
    hasSlackConnection
    hasTeamsInstallation
    hasTeamsTranscriptConnection
    hasGithubInstallation
    hasYoutrackIntegration
    youtrackUrl
    youtrackLastSync
    quarterStartMonth
    directorySync {
      id
      state
      type
      name
      lastSyncStart
      lastSyncEnd
    }
    userMembership {
      id
      role
    }
    featureFlags {
      actionItems
      feedbacks
      goals
      recognitions
      kpis
      explorer
      homepageMyConnections
      homepageMyConnectionsPeers
      workHistory
      askAi
      meetings
      reviewContextGeneration
    }
    # MEETING BOT
    enableMeetingBot
    enableMeetingSummarization
    transcribeMeetingsByDefault
    # AI GUIDELINES
    aiGuidelines
  }
`;

export default gql`
  ${OrgSettingsOrganizationFragment}
  query getOrganizationSettings {
    me {
      id
      organizations(personal: false) {
        edges {
          node {
            ...OrgSettingsOrganizationFragment
          }
        }
      }
    }
  }
`;
